import React, { useEffect, useState } from "react";
import axios from "axios";

import { API_BASE_URL } from "../../config/config";
import { OrbitProgress } from "react-loading-indicators";

const API_URL = `${API_BASE_URL}/users`;

export default function StorytellerUsers() {
  const [userCount, setUserCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserCount = async () => {
      try {
        const res = await axios.get(API_URL, { withCredentials: true });
        setUserCount(res.data.length);
      } catch (error) {
        console.error("Erreur de récupération :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserCount();
  }, []);

  return (
    <div className="">
      {loading ? (
        <div className="text-center text-gray-400"><OrbitProgress variant="track-disc" color="#125f69ff" size="small" text="" textColor="#484e51ff" /> </div>
      ) : (
        <>
           <Card title="Utilisateurs " value={userCount} change="" />
        </>
      )}
    </div>
  );
}


const Card = ({ title, value, change, isNegative = false }) => {
  const changeColor = isNegative ? "text-red-400" : "text-green-400";
  return (
    <div className="bg-[#121c31] p-4 border dark:border-gray-700 rounded-lg">
      <p className="text-2xl font-bold">{value}</p>
      <h1 className="text-bold text-gray-400">{title}</h1>
      <p className={`text-xs ${changeColor}`}>{change} </p>
    </div>
  );
};